import { createSlice } from "@reduxjs/toolkit";

const initialMyCoursesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  sections: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const myCourseSlice = createSlice({
  name: "myCourses",
  initialState: initialMyCoursesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getSections
    sectionsFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.sections = entities;
    },
    // getCourses
    coursesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanMyCoursesState
    myCoursesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});